
  <main [ngClass]="{'fixed-box-padding': addFixedBoxPadding, 'visible': lottoId===38}" role="main" >
    <router-outlet></router-outlet>
  </main>
